export const activityEntityType = value => ({ Companies: "company", Candidates: "candidate", Contacts: "contact", Leads: "lead", Jobs: "job", Users: "user" }[value] || "");
export const activityEntityLabel = type => ({ company: "Companies", candidate: "Candidates", contact: "Contacts", lead: "Leads", job: "Jobs", user: "Users" }[type] || "All Entities");

export function matchesActivityEntity(card, entity) {
  const selectedType = activityEntityType(entity);
  return !selectedType || String(card.reviewEntityType || card.entityType || "").toLowerCase() === selectedType;
}

export function selectActivityTotals(totals, entity) {
  const type = activityEntityType(entity);
  if (!type || !totals?.byEntity) return totals;
  const selected = totals.byEntity[type] || { review: 0, progress: 0, complete: 0, failed: 0, rejected: 0 };
  return { ...totals, ...selected, openTasks: selected.review + selected.progress };
}
